"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: ["currentFarm"],

    methods: {

        hasIcon: function hasIcon(name) {
            var value = _lodash2.default.chain(this.currentFarm.config.infos.icons).split(',').indexOf(name).value();
            return value > -1;
        }

    }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/additional-infos/AdditionalInfosComponent.vue
// module id = 390
// module chunks = 0